import locale from 'element-ui/lib/locale';
import language from 'element-ui/lib/locale/lang/en';

locale.use(language);